// src/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter as Router } from 'react-router-dom'; 
import "bootstrap/dist/css/bootstrap.min.css";
 // Ensure this line is correct


// Initialize sample users


ReactDOM.render(
  <Router>
    <AuthProvider>
    <App />
    </AuthProvider>
  </Router>,
  document.getElementById('root')
);
